module.exports = __webpack_public_path__ + "img/p25.6b131461.png";